import { InjectionToken } from '@angular/core';
import { IBaseEntityService } from '../interfaces/entities/base-entity-service.interface';
import { ICourseEntityService } from '../interfaces/entities/course-entity-service.interface';
import { ICustomerEntityService } from '../interfaces/entities/customer-entity-service.interface';
import { ITrainerEntityService } from '../interfaces/entities/trainer-entity-service.interface';
import { EntityBase } from '../models/entities/entity-base';
import { IRequisitionEntityService } from '../interfaces/entities/requisition-entity-service-interface';
import { IClassesEntityService } from '../interfaces/entities/classes-entity-service.interface';
import { IWizardService } from '../interfaces/wizard-service.interface';

/**
 * Injection token for the base entity service
 */
export const BASE_ENTITY_SERVICE_TOKEN = new InjectionToken<IBaseEntityService<EntityBase>>('BASE_ENTITY_SERVICE_TOKEN');

/**
 * Injection token for the trainer entity service
 */
export const TRAINER_ENTITY_SERVICE_TOKEN = new InjectionToken<ITrainerEntityService>('TRAINER_ENTITY_SERVICE_TOKEN');

/**
 * Injection token for the customer entity service
 */
export const CUSTOMER_ENTITY_SERVICE_TOKEN = new InjectionToken<ICustomerEntityService>('CUSTOMER_ENTITY_SERVICE_TOKEN');

/**
 * Injection token for the course entity service
 */
export const COURSE_ENTITY_SERVICE_TOKEN = new InjectionToken<ICourseEntityService>('COURSE_ENTITY_SERVICE_TOKEN');


/**
 * Injection token for the requisition  entity service
 */
export const REQUISITION_ENTITY_SERVICE_TOKEN = new InjectionToken<IRequisitionEntityService>('REQUISITION_ENTITY_SERVICE_TOKEN');

/**
 * Injection token for the classes entity service
 */
export const CLASSES_ENTITY_SERVICE_TOKEN = new InjectionToken<IClassesEntityService>('CLASSES_ENTITY_SERVICE_TOKEN');

export const REQUISITION_WIZARD_SERVICE_TOKEN = new InjectionToken<IWizardService>('REQUISITION_WIZARD_SERVICE_TOKEN');
